import { render } from "./anchor.vue?vue&type=template&id=147260c4&scoped=true"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"

import "./anchor.vue?vue&type=style&index=0&id=147260c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147260c4"]])

export default __exports__